/**
 * Shared filter row for Binom pickers — primary dropdown (group), free-text
 * search, and 0–2 additional dropdowns (language / country / AN).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';

import { Input } from '@/components/ui/form/input/Input';

export interface PickerFilterRowProps {
  primary: ReactNode;
  search: string;
  onSearchChange: (next: string) => void;
  extras?: ReactNode;
}

const PickerFilterRow: FC<PickerFilterRowProps> = ({
  primary,
  search,
  onSearchChange,
  extras,
}) => (
  <div className="flex flex-wrap items-center gap-2 pb-2">
    <div className="min-w-[10rem] flex-1">{primary}</div>
    {extras}
    <Input
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Search…"
      className="h-8 flex-1 text-xs"
    />
  </div>
);

export default PickerFilterRow;
